import fetch from 'utils/fetch';

export const REQUEST_THREADS = 'REQUEST_THREADS';
export const RECEIVE_THREADS = 'RECEIVE_THREADS';
export const FILTER_THREADS = 'FILTER_THREADS';
export const FILTER_UNREAD_THREADS = 'FILTER_UNREAD_THREADS';
export const FILTER_STARED_THREADS = 'FILTER_STARED_THREADS';
export const THREAD_STARED = 'THREAD_STARED';

function requestThreads() {
  return {
    type: REQUEST_THREADS,
  };
}

function receiveThreads(threads) {
  return {
    type: RECEIVE_THREADS,
    payload: {
      threads,
    },
  };
}

function fetchThreads() {
  return dispatch => {
    dispatch(requestThreads());
    fetch('/messaging/mailbox.json')
      .then(r => r.json())
      .then(threads => dispatch(receiveThreads(threads)));
  };
}

function shouldFetchThreads(state) {
  const { loaded, isFetching, didInvalidate } = state.messaging.threads;
  if (!loaded) {
    return true;
  } else if (isFetching) {
    return false;
  }

  return didInvalidate;
}

function threadStared(user, isStared) {
  return {
    type: THREAD_STARED,
    payload: {
      user,
      isStared,
    },
  };
}

export function fetchThreadsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchThreads(getState())) {
      dispatch(fetchThreads());
    }
  };
}

export function filterThreads(filter) {
  return {
    type: FILTER_THREADS,
    payload: {
      filter,
    },
  };
}

export function filterUnreadThreads() {
  return {
    type: FILTER_UNREAD_THREADS,
  };
}

export function filterStaredThreads() {
  return {
    type: FILTER_STARED_THREADS,
  };
}

export function starThread(user) {
  return (dispatch, getState) => {
    const message = getState().messaging.threads.messages.get(user.toString());

    let request;
    if (message.isStared) {
      request = fetch(`/messaging/${user}/star`, {
        method: 'DELETE',
      });
    } else {
      request = fetch(`/messaging/${user}/star`, {
        method: 'PUT',
      });
    }

    return request.then(() => dispatch(threadStared(user, !message.isStared)));
  };
}



// WEBPACK FOOTER //
// ./src/modules/messaging/actions/thread.js